export const styleShadowDom = (element: HTMLElement, styles: string) => {
  if (element && element.shadowRoot) {
    const shadowRoot = element.shadowRoot;
    if ('adoptedStyleSheets' in shadowRoot) {
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(styles);
      shadowRoot.adoptedStyleSheets.push(sheet);
    } else {
      const styleElement = document.createElement('style');
      styleElement.textContent = styles;
      shadowRoot.appendChild(styleElement);
    }
  }
};
